/**
 * Renders the guest wishlist page from AmadaWishlist (localStorage).
 * Fetches each product via /products/{handle}.js
 */

(function () {
  function money(cents, format) {
    var amount = (Number(cents) / 100).toFixed(2);
    if (!format) return '£' + amount;
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function imageUrl(product) {
    var src = product.featured_image || (product.images && product.images[0]) || '';
    if (!src) return '';
    if (typeof src === 'object') src = src.src || '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function firstAvailableVariant(product) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i] && variants[i].available) return variants[i];
    }
    return null;
  }

  function heartSvg() {
    return (
      '<svg viewBox="-1.5 -1 23 22" aria-hidden="true" focusable="false">' +
      '<path d="M9.5 17.5 2 10.2A5.2 5.2 0 0 1 9.5 3.2a5.2 5.2 0 0 1 7.5 7L9.5 17.5z" ' +
      'fill="currentColor" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/>' +
      '</svg>'
    );
  }

  function cartAddUrl() {
    return (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
  }

  function openCart() {
    var actions = window.Shopify && Shopify.actions;
    if (actions && typeof actions.openCart === 'function') {
      return Promise.resolve(actions.openCart());
    }
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return Promise.resolve();
    }
    var trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) trigger.click();
    return Promise.resolve();
  }

  function refreshCart() {
    var actions = window.Shopify && Shopify.actions;
    if (actions && typeof actions.updateCart === 'function') {
      return Promise.resolve(actions.updateCart());
    }
    return fetch(((typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart') + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    });
  }

  function addToBag(variantId, button, addingLabel) {
    if (!variantId || !button) return;
    var original = button.textContent;
    button.disabled = true;
    button.textContent = addingLabel || 'Adding';

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            throw new Error(data.description || data.message || 'Could not add to bag');
          }
          return data;
        });
      })
      .then(function () {
        return refreshCart();
      })
      .then(function () {
        return openCart();
      })
      .catch(function () {
        window.location.href = (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart';
      })
      .finally(function () {
        button.disabled = false;
        button.textContent = original;
      });
  }

  function init(root) {
    if (!root || !window.AmadaWishlist) return;

    var grid = root.querySelector('[data-amada-wishlist-grid]');
    var empty = root.querySelector('[data-amada-wishlist-empty]');
    var countEl = root.querySelector('[data-amada-wishlist-page-count]');
    var emptyHeading = root.querySelector('[data-amada-wishlist-empty-heading]');
    var emptyText = root.querySelector('[data-amada-wishlist-empty-text]');

    var moneyFormat = root.getAttribute('data-money-format') || '';
    var removeLabel = root.getAttribute('data-remove-label') || 'Remove from saved';
    var addLabel = root.getAttribute('data-add-label') || 'Add to bag';
    var addingLabel = root.getAttribute('data-adding-label') || 'Adding';
    var viewLabel = root.getAttribute('data-view-label') || 'View options';
    var reloadTimer;
    var suppressReload = false;

    if (emptyHeading) emptyHeading.textContent = root.getAttribute('data-empty-heading') || '';
    if (emptyText) emptyText.textContent = root.getAttribute('data-empty-text') || '';

    function setCount(n) {
      if (!countEl) return;
      if (!n) {
        countEl.hidden = true;
        countEl.textContent = '';
        return;
      }
      countEl.hidden = false;
      countEl.textContent = n === 1 ? '1 piece' : n + ' pieces';
    }

    function showEmpty(on) {
      if (empty) empty.hidden = !on;
      if (grid) grid.hidden = on;
      if (on) setCount(0);
    }

    function renderCard(product) {
      var img = imageUrl(product);
      var href = product.url || '/products/' + product.handle;
      var price = money(product.price, moneyFormat);
      var variant = firstAvailableVariant(product);
      var title = escapeHtml(product.title);
      var article = document.createElement('article');
      article.className = 'amada-wishlist__card';
      article.dataset.productId = String(product.id);

      var bagHtml = variant
        ? '<button type="button" class="amada-wishlist__bag" data-amada-add="' +
          variant.id +
          '">' +
          escapeHtml(addLabel) +
          '</button>'
        : '<a class="amada-wishlist__bag" href="' +
          escapeHtml(href) +
          '">' +
          escapeHtml(viewLabel) +
          '</a>';

      article.innerHTML =
        '<div class="amada-wishlist__media">' +
        '<a href="' +
        escapeHtml(href) +
        '">' +
        (img
          ? '<img src="' +
            escapeHtml(img) +
            '" alt="' +
            title +
            '" loading="lazy" width="600" height="750">'
          : '') +
        '</a>' +
        '<button type="button" class="amada-wishlist__save" aria-pressed="true" aria-label="' +
        escapeHtml(removeLabel) +
        '" data-amada-save data-product-id="' +
        product.id +
        '" data-product-handle="' +
        escapeHtml(product.handle) +
        '">' +
        heartSvg() +
        '</button>' +
        '</div>' +
        '<div class="amada-wishlist__body">' +
        '<a class="amada-wishlist__title" href="' +
        escapeHtml(href) +
        '">' +
        title +
        '</a>' +
        '<p class="amada-wishlist__price">' +
        escapeHtml(price) +
        '</p>' +
        bagHtml +
        '</div>';

      var addBtn = article.querySelector('[data-amada-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          addToBag(Number(addBtn.getAttribute('data-amada-add')), addBtn, addingLabel);
        });
      }
      return article;
    }

    function load() {
      var items = window.AmadaWishlist.getItems();
      if (!items.length) {
        if (grid) grid.innerHTML = '';
        showEmpty(true);
        return;
      }

      showEmpty(false);
      setCount(items.length);
      if (grid) grid.innerHTML = '';

      var pending = items.length;
      var results = new Array(items.length);
      var stale = [];

      items.forEach(function (item, index) {
        fetch('/products/' + encodeURIComponent(item.handle) + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('missing');
            return res.json();
          })
          .then(function (product) {
            results[index] = product;
          })
          .catch(function () {
            stale.push(String(item.id));
            results[index] = null;
          })
          .finally(function () {
            pending -= 1;
            if (pending > 0) return;

            if (stale.length && window.AmadaWishlist.getItems) {
              var kept = window.AmadaWishlist.getItems().filter(function (entry) {
                return stale.indexOf(String(entry.id)) === -1;
              });
              try {
                suppressReload = true;
                localStorage.setItem(window.AmadaWishlist.STORAGE_KEY, JSON.stringify(kept));
                document.dispatchEvent(
                  new CustomEvent('amada:wishlist:change', {
                    detail: { items: kept, count: kept.length },
                  })
                );
              } catch (e) {
                /* ignore */
              } finally {
                suppressReload = false;
              }
            }

            var alive = results.filter(Boolean);
            if (!alive.length) {
              if (grid) grid.innerHTML = '';
              showEmpty(true);
              return;
            }
            setCount(alive.length);
            alive.forEach(function (product) {
              grid.appendChild(renderCard(product));
            });
            if (window.AmadaWishlist.hydrate) window.AmadaWishlist.hydrate(grid);
          });
      });
    }

    function scheduleReload() {
      if (suppressReload) return;
      clearTimeout(reloadTimer);
      reloadTimer = setTimeout(load, 50);
    }

    load();
    document.addEventListener('amada:wishlist:change', scheduleReload);
  }

  function boot() {
    document.querySelectorAll('[data-amada-wishlist]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
